export type ReferralOffer = 'loading' | 'valid' | 'invalid' | 'unavailable';

export const GENERIC_HEADLINE = 'Share who you are and remember who you meet';
export const GENERIC_SUBTITLE =
  'Digital business cards and AI contact capture for every opportunity.';
export const INVALID_SUBTITLE =
  'This referral link is no longer valid, but Blinq is free to start.';
export const OFFER_SUBTITLE = 'Make the best impression. Never miss an opportunity.';
export const START_FOR_FREE_LABEL = 'Start for free';

export function buildReferralHeadline(firstName: string | null, discountPercent: number): string {
  return firstName
    ? `${firstName} sent you ${discountPercent}% off Blinq`
    : `You've been given ${discountPercent}% off Blinq`;
}

export function buildClaimLabel(discountPercent: number): string {
  return `Claim ${discountPercent}% off`;
}

export function buildCtaLabel(offer: ReferralOffer, discountPercent: number): string {
  return offer === 'valid' ? buildClaimLabel(discountPercent) : START_FOR_FREE_LABEL;
}
